import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UpdateFormValue } from '@ngxs/form-plugin';
import {
  ApplicationSelectorState,
  ConfigState,
  SetAdminMenuItem,
  SetInitialData,
  SetRegularMenuItems,
  SetUserAsAdmin,
  SetUserAsDICMember,
} from '../../state';
import { InitialDataStateModel } from '../../../model';

@Injectable({
  providedIn: 'root',
})
export class InitialDataService {
  private readonly store = inject(Store);
  private readonly http = inject(HttpClient);

  baseApiUrl = this.store.selectSignal(ConfigState.baseApiUrl);

  getInitialData(): Observable<InitialDataStateModel> {
    const url = `${this.baseApiUrl()}/initial-data`;
    return this.http.get<InitialDataStateModel>(url).pipe(
      tap((response: InitialDataStateModel) => {
        if (response.applicationList.length > 0) {
          this.store.dispatch(
            [
              new SetInitialData(response),
              new SetUserAsDICMember(),
              new SetRegularMenuItems(),
              response.userData.isAdmin ? [new SetUserAsAdmin(), new SetAdminMenuItem()] : [],
              // Only if no application/environment is selected before, select the first available application and env
            ].flat()
          );
        }
        if (!this.store.selectSnapshot(ApplicationSelectorState.applicationSelectorFormValues)?.application?.value) {
          this.store.dispatch(
            new UpdateFormValue({
              path: 'applicationSelector.applicationForm',
              value: {
                application: response.applicationList[0],
                environment: response.environmentList.main[0],
              },
            })
          );
        }
      })
    );
  }
}
